import {
  getRankingCategoryLabel,
  getRankingDriverName,
  getRankingTeamName,
  getRankingTeamNumber,
} from "../../utils/ranking.utils";

const RankingsTable = ({ rankings = [], categories = [] }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 90 }}>Position</th>
            <th style={{ minWidth: 160 }}>Team</th>
            <th style={{ width: 100 }}>Team #</th>
            <th style={{ minWidth: 140 }}>Driver</th>
            <th style={{ minWidth: 120 }}>Category</th>
            <th style={{ width: 110 }}>After stage</th>
            <th style={{ minWidth: 120 }}>Total time</th>
            <th style={{ minWidth: 120 }}>Total penalty</th>
            <th style={{ width: 90 }}>Points</th>
          </tr>
        </thead>
        <tbody>
          {rankings.map((entry, index) => {
            const id = entry._id || entry.id || `${index}-${entry.position}`;
            return (
              <tr key={id}>
                <td>{entry.position ?? "-"}</td>
                <td>{getRankingTeamName(entry)}</td>
                <td>{getRankingTeamNumber(entry)}</td>
                <td>{getRankingDriverName(entry)}</td>
                <td>{getRankingCategoryLabel(entry, categories)}</td>
                <td>
                  {entry.after_stage === 0 || entry.after_stage
                    ? entry.after_stage
                    : "-"}
                </td>
                <td>{entry.total_time || "-"}</td>
                <td>{entry.total_penalty || "-"}</td>
                <td>
                  {entry.points === 0 || entry.points ? entry.points : "-"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RankingsTable;
